import { put, call, take, race } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
//import ReconnectingWebsSocket from 'reconnecting-websocket';
import { WebSocketBridge } from '../common/webSocketBridge';
import humps from 'humps';

export function* wsHandling() {
    while (true) {
        yield take('START_WEBSOCKET');
        const ws = new WebSocketBridge();
        if (process.env.NODE_ENV === 'development') {
            ws.connect("ws://192.168.1.138:8000/ws/", ["Token", localStorage.getItem('token')]);
        } else {
            ws.connect("wss://www.addictguild.com/ws/", ["Token", localStorage.getItem('token')]);
        }

        const socketChannel = yield call(watchMessages, ws);
        // Establish presence heartbeat
        const { cancel } = yield race({
            task: [
                call(externalListener, socketChannel),
                call(internalListener, ws),
            ],
            cancel: take('STOP_WEBSOCKET')
        });
        if (cancel) {
            ws.close(1000, 'Auth Reconnect', {keepClosed: true});
        }
    }
}

function watchMessages(socket) {
    return eventChannel((emit) => {
        // When connection established send location create heartbeat interval
        let heartbeat = null;
        socket.socket.addEventListener('open', function() {
            socket.send({ location: window.location.pathname });
            heartbeat = setInterval(function() {
                socket.send("heartbeat");
            }, 30000);
        });
        // When connection closed remove heartbeat interval
        socket.socket.addEventListener('close', function() {
            window.clearInterval(heartbeat)
        });

        socket.listen(function(action, stream) {
            // convert from string to JSON and camelize
            let data = humps.camelizeKeys(action);
            emit({
                type: 'SOCKET_'+data.type.toUpperCase(),
                data: data
            });
        });
        return () => {
            socket.close();
        };
    })
}

function* externalListener (socketChannel) {
    while (true) {
        const action = yield take(socketChannel);
        yield put(action);
    }
}

function* internalListener(socket) {
    while (true) {
        const data = yield take('SEND_LOCATION');
        socket.send({ location: data.location })
    }
}



// WEBPACK FOOTER //
// ./src/redux/socket.js